import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/link.js");
